import ReactDOM from "react-dom";
import { attorneyStatusesOptions, attorneyStatusUnattached } from '../../../../lib/systemData'
import { useDispatch, useSelector } from "react-redux"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { formatDate } from "../../../../lib/script"
import { useEffect, useState } from "react"
import { useMemo } from "react"
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import Button from "../../../common/Button";
import InputBox from "../../../common/interactive/InputBox";
import CustomSelect from "../../../common/interactive/CustomSelect";
import Modal from "../../../common/Modal";
import Tag from "../../../fragments/Tag";
import Backdrop from "../../../common/modal/Backdrop";

const AttorneyStatusContainer = ({data}) => {
    const dispatch = useDispatch()
    const attorneyStatusOptionsData = useMemo(() => attorneyStatusesOptions(), [])

    const [selectedOption,setSelectedoption] = useState(null)
    const [currentStatusValue, setCurrentStatusValue] = useState(data.status_id ?? null)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const [modelOpened, setModalopened] = useState(false)
    const updateHandler = async (data) => {  
        setSelectedoption(data.data.value)
        setCurrentStatusValue(data.data.value ?? null)
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }   

        if (data?.option?.atty_dropped) { //attorney drop option --> need confirmation // old functionality: data.data.value == 5
            setModalopened(true)
        } else {
            let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } 
            
        }      
               
        
    }

    const openModalHandler = () => {
        setModalopened(false)
    }

    const [loading, setloading] = useState(false)
    const dropAttorneyhandler = async (event) => {
        event.preventDefault()
        setloading(true)
        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            let reqBody = {
                type: 'case_attorney',
                type_id:  data.id,
                fields: {
                    status_id : selectedOption,
                    drop_reason: formData.drop_reason,
                    drop_date: formatDate(new Date())
                }
            }  

            let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

            if (update?.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {
                setModalopened(false)
            }
        } finally {
            setloading(false)
        }
    }

    useEffect(() => {
        setCurrentStatusValue(data.status_id ?? null)
    }, [data.status_id])

    return <div className="relative">
        <CustomSelect
            optionsData={attorneyStatusOptionsData}
            label={'Atty Status'}
            preSelectedValue={currentStatusValue}
            action={updateHandler}
            identifier={{type: 'case_attorney', field: 'status_id', type_id: data.id}}
            hasRemove={true}
            fallbackSelectedOption={(value) => {
                const found = attorneyStatusUnattached()?.find(item => item.value == value)
                if (!found) return null
                return { ...found, isDisabled: true }
            }}
        />

        {modelOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={openModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={openModalHandler} modalTitle={'Drop Attorney?'}>
                        <PannelBody background={"var(--line-transparent)"}>
                            <div className='flex-vertical-center'>
                                {data.law_firm.name}
                                <Tag type={'note'}>{data.law_firm.code}</Tag>
                            </div>                            
                        </PannelBody>
                        <PannelBody>
                            <form onSubmit={dropAttorneyhandler}>
                                <div className="row">
                                    <InputBox label={'Reason'} type={'text'} name={'drop_reason'}/>
                                </div>
                                <div className="row">
                                    <p className="font-14">
                                        Are you sure you want to drop this attorney?
                                    </p>     
                                    <div className='flex-container-equal m-top-24'>
                                        <Button btnStyle={'btn_danger'} type={'submit'} isLoading={loading}><i className="ti ti-trash"></i>Drop</Button>
                                        <Button click={openModalHandler} type={'button'}>Cancel</Button>
                                    </div>     
                                </div>     
                            </form>                    
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}

export default AttorneyStatusContainer